module.exports = __webpack_public_path__ + "static/media/applogo.d2d9e434.png";